export const GET_PRODUCT_TEACHERS_REQUEST = 'GET_PRODUCT_TEACHERS_REQUEST';
export const GET_PRODUCT_TEACHERS_SUCCESS = 'GET_PRODUCT_TEACHERS_SUCCESS';
export const GET_PRODUCT_TEACHERS_FAILURE = 'GET_PRODUCT_TEACHERS_FAILURE';

export const getProductTeachers = productId =>
    ({ type: GET_PRODUCT_TEACHERS_REQUEST, productId });

export const getProductTeachersSuccess = ({ data }) =>
    ({ type: GET_PRODUCT_TEACHERS_SUCCESS, data });

export const getProductTeachersFailure = () =>
    ({ type: GET_PRODUCT_TEACHERS_FAILURE });

export const DOWNLOAD_TEACHER_ROLL_REQUEST = 'DOWNLOAD_TEACHER_ROLL_REQUEST';
export const DOWNLOAD_TEACHER_ROLL_SUCCESS = 'DOWNLOAD_TEACHER_ROLL_SUCCESS';
export const DOWNLOAD_TEACHER_ROLL_FAILURE = 'DOWNLOAD_TEACHER_ROLL_FAILURE';

export const downloadTeacherRoll = (teachers, isTeacherRollDownloaded) =>
    ({ type: DOWNLOAD_TEACHER_ROLL_REQUEST, teachers, isTeacherRollDownloaded });

export const downloadTeacherRollSuccess = (downloadUrl, isTeacherRollDownloaded) => {
    window.location.href = downloadUrl;
    return ({ type: DOWNLOAD_TEACHER_ROLL_SUCCESS, isTeacherRollDownloaded });
};

export const downloadTeacherRollFailure = () => ({ type: DOWNLOAD_TEACHER_ROLL_FAILURE });

export const TEACHER_FILTER_VALUE_CLEARED = 'TEACHER_FILTER_VALUE_CLEARED';
export const TEACHER_FILTER_VALUE_CHANGED = 'TEACHER_FILTER_VALUE_CHANGED';
export const UPDATE_TEACHER_SEARCH_TERM = 'UPDATE_TEACHER_SEARCH_TERM';
export const SORT_TEACHER_LIST = 'SORT_TEACHER_LIST';
export const RETRIEVE_SELECTED_TEACHER = 'RETRIEVE_SELECTED_TEACHER';

export const clearFilterValue = () => ({ type: TEACHER_FILTER_VALUE_CLEARED });

export const changeFilterValue = (collectionName, key) => ({ type: TEACHER_FILTER_VALUE_CHANGED, collectionName, key });

export const updateSearchTerm = searchTerm => ({ type: UPDATE_TEACHER_SEARCH_TERM, searchTerm });

export const sortTeacherList = columnToSort => ({ type: SORT_TEACHER_LIST, columnToSort });

export const retrieveSelectedTeachers = selectedTeachersProfileId => ({
    type: RETRIEVE_SELECTED_TEACHER,
    selectedTeachers: selectedTeachersProfileId
});

export const UNASSIGN_TEACHERS_REQUEST = 'UNASSIGN_TEACHERS_REQUEST';
export const UNASSIGN_TEACHERS_SUCCESS = 'UNASSIGN_TEACHERS_SUCCESS';
export const UNASSIGN_TEACHERS_FAILURE = 'UNASSIGN_TEACHERS_FAILURE';

export const unassignTeachers = (selectedTeachers, productId) =>
    ({ type: UNASSIGN_TEACHERS_REQUEST, selectedTeachers, productId, disableConfirmationButtons: true });

export const unassignTeachersSuccess = () =>
    ({ type: UNASSIGN_TEACHERS_SUCCESS, isUserOperationModalOpen: false, disableConfirmationButtons: false });

export const unassignTeachersFailure = () =>
    ({ type: UNASSIGN_TEACHERS_FAILURE, disableConfirmationButtons: false });

export const OPEN_UNASSIGN_TEACHERS_MODAL = 'OPEN_UNASSIGN_TEACHERS_MODAL';
export const CLOSE_TEACHERS_OPERATION_CONFIRMATION_MODAL = 'CLOSE_TEACHERS_OPERATION_CONFIRMATION_MODAL';

export const openUnAssignTeachersModal = () =>
    ({ type: OPEN_UNASSIGN_TEACHERS_MODAL, isUserOperationModalOpen: true, operationType: 'unassignTeacher' });

export const closeTeachersOperationConfirmationModal = () =>
    ({ type: CLOSE_TEACHERS_OPERATION_CONFIRMATION_MODAL, deleteSuccess: false, refreshTeacherList: true, selectedTeachers: [] });

export const PRINT_TEACHER_SIGN_IN_CARD_REQUEST = 'PRINT_TEACHER_SIGN_IN_CARD_REQUEST';
export const PRINT_TEACHER_SIGN_IN_CARD_SUCCESS = 'PRINT_TEACHER_SIGN_IN_CARD_SUCCESS';
export const PRINT_TEACHER_SIGN_IN_CARD_FAILURE = 'PRINT_TEACHER_SIGN_IN_CARD_FAILURE';

export const printTeacherSignInCard = (productId, teacherSignInCardsData) =>
    ({ type: PRINT_TEACHER_SIGN_IN_CARD_REQUEST, isSignInCardDownloaded: false, teacherSignInCardsData, productId });

export const printTeacherSignInCardSuccess = (downloadUrl, isSignInCardDownloaded) => {
    window.location.href = downloadUrl;
    return ({ type: PRINT_TEACHER_SIGN_IN_CARD_SUCCESS, downloadUrl, isSignInCardDownloaded });
};

export const printTeacherSignInCardFailure = isSignInCardDownloaded =>
    ({ type: PRINT_TEACHER_SIGN_IN_CARD_FAILURE, isSignInCardDownloaded });

export const ADD_TEACHER_OPEN_MODAL_REQUEST = 'ADD_TEACHER_OPEN_MODAL_REQUEST';
export const ADD_TEACHER_CLOSE_MODAL_REQUEST = 'ADD_TEACHER_CLOSE_MODAL_REQUEST';
export const ADD_ANOTHER_TEACHER_OPEN_MODAL_REQUEST = 'ADD_ANOTHER_TEACHER_OPEN_MODAL_REQUEST';

export function openAddTeacherModal() {
    return {
        type: ADD_TEACHER_OPEN_MODAL_REQUEST,
        showModal: true,
        showAddTeacherConfirmationModal: false
    };
}

export function addAnotherTeacherModal() {
    return {
        type: ADD_ANOTHER_TEACHER_OPEN_MODAL_REQUEST,
        showModal: true,
        showAddTeacherConfirmationModal: false
    };
}

export function closeAddTeacherModal() {
    return {
        type: ADD_TEACHER_CLOSE_MODAL_REQUEST,
        showModal: false
    };
}

export const ADD_TEACHER_REQUEST = 'ADD_TEACHER_REQUEST';
export const ADD_TEACHER_SUCCESS = 'ADD_TEACHER_SUCCESS';
export const ADD_TEACHER_FAILURE = 'ADD_TEACHER_FAILURE';

export const addTeacher = teacher =>
    ({ type: ADD_TEACHER_REQUEST, teacher, isSaveInProgress: true });

export function addTeacherSuccess(userProfileId) {
    return {
        type: ADD_TEACHER_SUCCESS,
        userProfileId,
        isSaveInProgress: false,
        showAddTeacherConfirmationModal: true
    };
}

export function addTeacherFailure(isServerError, addTeacherValidationMessage) {
    return {
        type: ADD_TEACHER_FAILURE,
        addTeacherValidationMessage,
        showAddTeacherValidationModal: true,
        isSaveInProgress: false,
        isServerError
    };
}

export const CLOSE_ADD_TEACHER_VALIDATION_MODAL = 'CLOSE_ADD_TEACHER_VALIDATION_MODAL';

export function closeAddTeacherValidationModal() {
    return {
        type: CLOSE_ADD_TEACHER_VALIDATION_MODAL,
        showAddTeacherValidationModal: false
    };
}

export const OPEN_DELETE_TEACHER_MODAL = 'OPEN_DELETE_TEACHER_MODAL';

export const openDeleteTeacherModal = () =>
    ({ type: OPEN_DELETE_TEACHER_MODAL, isUserOperationModalOpen: true, operationType: 'deleteTeacher', selectedTeachers: [], notDeletedTeachers: [], deleteSuccess: false });

export const DELETE_TEACHER_REQUEST = 'DELETE_TEACHER_REQUEST';
export const DELETE_TEACHER_SUCCESS = 'DELETE_TEACHER_SUCCESS';
export const DELETE_TEACHER_FAILURE = 'DELETE_TEACHER_FAILURE';

export const deleteTeacherRequest = userProfileIds =>
    ({ type: DELETE_TEACHER_REQUEST, deletingTeacher: true, deleteSuccess: false, disableConfirmationButtons: true, userProfileIds, operationType: 'deleteTeacher' });

export const deleteTeacherSuccess = notDeletedTeachers =>
    ({
        type: DELETE_TEACHER_SUCCESS,
        deletingTeacher: false,
        deleteSuccess: true,
        refreshTeacherList: true,
        isUserOperationModalOpen: false,
        disableConfirmationButtons: false,
        notDeletedTeachers,
        selectedTeachers: []
    });

export const deleteTeacherFailure = () =>
    ({ type: DELETE_TEACHER_FAILURE, deletingTeacher: false, deleteSuccess: false, disableConfirmationButtons: false });

export const SEND_VERIFICATION_EMAIL_REQUEST = 'SEND_VERIFICATION_EMAIL_REQUEST';
export const SEND_VERIFICATION_EMAIL_SUCCESS = 'SEND_VERIFICATION_EMAIL_SUCCESS';
export const SEND_VERIFICATION_EMAIL_FAILURE = 'SEND_VERIFICATION_EMAIL_FAILURE';

export const sendVerificationEmailRequest = userProfileIds => ({ type: SEND_VERIFICATION_EMAIL_REQUEST, userProfileIds });

export const sendVerificationEmailSuccess = result => (
    {
        type: SEND_VERIFICATION_EMAIL_SUCCESS,
        results: {
            totalRequests: result.totalRequests,
            successfulSending: result.successfulRequests,
            alreadyVerifiedEmails: result.alreadyVerifiedEmails,
            duplicateEmails: result.duplicateEmails,
            invalidRequests: result.invalidRequests
        }
    }
);

export const sendVerificationEmailFailure = message => ({ type: SEND_VERIFICATION_EMAIL_FAILURE, message });

export const CLOSE_EMAIL_VERIFICATION_MODAL = 'CLOSE_EMAIL_VERIFICATION_MODAL';

export const closeVerificationModal = () => (
    { type: CLOSE_EMAIL_VERIFICATION_MODAL }
);



// WEBPACK FOOTER //
// ./app/containers/teacher-roll/actions.js